import React from 'react';
import { View, Text, StyleSheet, Image, TouchableOpacity, TouchableHighlight, Keyboard, Platform, Dimensions } from 'react-native';
import Colors from '../../constants/Colors';
import CS from '../../constants/Styles';
import Images from '../../constants/Images';
import { TextInputContainer, Button, BackgroundGradient, Validate, Loader, AddressPicker, ULItem, PhotoId, PhotoIdText, ToggleButtons, Storage, Alert, ToolTipWrapper } from '../../components';
import * as rtApi from '../../components/Api';
import UserAvatar from '../../components/Users/UserAvatar';
import { FontAwesome, FontAwesome5 } from '@expo/vector-icons';
import { acceptableIds, addressToolTip } from '../../constants/Arrays';
import { processLoginAccount, formatPhoneNumber, getImageFieldsForUpload, isLocalAuthenticationAvailable, manipulateImage, dataUrlToFile, showAlert, isImageExtensionValid } from '../../utils/Functions';
import { useHeaderHeight } from '@react-navigation/elements';
import { useFocusEffect } from '@react-navigation/native';
// import Constants from 'expo-constants';
// import { BlurView } from 'expo-blur';
import { Camera, CameraType } from 'expo-camera';
import * as ImagePicker from 'expo-image-picker';
import * as DocumentPicker from 'expo-document-picker';
import Constants from 'expo-constants';
import UserState from '../../src/contexts/UserState';
import * as Localization from 'expo-localization';
// import * as SecureStore from 'expo-secure-store';
import * as LocalAthentication from 'expo-local-authentication';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
// import { Notifier, Easing, NotifierComponents } from 'react-native-notifier';
import { useLinkTo } from '@react-navigation/native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

// import * as WebBrowser from 'expo-web-browser';

const PersonalProfile = ({ navigation, route }) => {
  const [user, setUser] = React.useContext(UserState);
  const [alertOptions, setAlertOptions] = React.useState({});

  const [existingProfile, setExistingProfile] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [avatar, setAvatar] = React.useState(null);
  const [avatarChanged, setAvatarChanged] = React.useState(null);
  const [emailAddress, setEmailAddress] = React.useState('');
  const [currentEmailAddress, setCurrentEmailAddress] = React.useState('');
  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [phoneNumberHome, setPhoneNumberHome] = React.useState('');
  const [phoneNumberMobile, setPhoneNumberMobile] = React.useState('');
  // const [isMobile, setIsMobile] = React.useState(true);
  const [address, setAddress] = React.useState('');
  const [streetId, setStreetId] = React.useState(null);
  const [streetNumber, setStreetNumber] = React.useState(null);
  const [addressUnit, setAddressUnit] = React.useState(null);
  const [addressSuggestions, setAddressSuggestions] = React.useState([]);
  const [addressLoading, setAddressLoading] = React.useState(false);
  const [showAddressSuggestionOverlay, setShowAddressSuggestionOverlay] = React.useState(false);
  const [cameraPreview, setCameraPreview] = React.useState(false);
  const [cameraType, setCameraType] = React.useState(CameraType.front);
  const [timezone, setTimezone] = React.useState(null);
  const [locale, setLocale] = React.useState(null);
  const [photoIds, setPhotoIds] = React.useState([]);
  const [showMore, setShowMore] = React.useState(false);
  const [emergency1Name, setEmergency1Name] = React.useState('');
  const [emergency1PhoneNumber, setEmergency1PhoneNumber] = React.useState('');
  const [emergency1EmailAddress, setEmergency1EmailAddress] = React.useState('');
  const [emergency1Relationship, setEmergency1Relationship] = React.useState('');
  const [emergency2Name, setEmergency2Name] = React.useState('');
  const [emergency2PhoneNumber, setEmergency2PhoneNumber] = React.useState('');
  const [emergency2EmailAddress, setEmergency2EmailAddress] = React.useState('');
  const [emergency2Relationship, setEmergency2Relationship] = React.useState('');
  
  const [showLocalAuthentication, setShowLocalAuthentication] = React.useState(false);
  const [useLocalAuthentication, setUseLocalAuthentication] = React.useState(false);
  const [localAuthenticationMessage, setLocalAuthenticationMessage] = React.useState('Would you like to use local authentication instead of 2-Factor Authentication (2FA), when you login, release money to contractors or withdraw money?');

  const [marketingCommunication, setMarketingCommunication] = React.useState(false);
  const [marketingCommunicationChanged, setMarketingCommunicationChanged] = React.useState(false);

  const [photoIdPreview, setPhotoIdPreview] = React.useState(false);
  const [photoIdPreviewLayoutY, setPhotoIdPreviewLayoutY] = React.useState(0);

  let photoIdRef = null;
  let scrollRef = React.useRef(null);
  const linkTo = useLinkTo();
  // let scrollRef = null;

  const headerHeight = useHeaderHeight();
  const screenWidth = Platform.OS === 'web' ? 768 : Dimensions.get('window').width;
  const middleScreen = screenWidth / 2 - 10;
  const insets = useSafeAreaInsets();

  const defaultIsInvalid = {
    emailAddress: false,
    firstName: false,
    lastName: false,
    phoneNumberHome: false,
    phoneNumberMobile: false,
    houseAddress: false,
    emergency1Name: false,
    emergency1PhoneNumber: false,
    emergency1EmailAddress: false,
    emergency1Relationship: false,
    emergency2Name: false,
    emergency2PhoneNumber: false,
    emergency2EmailAddress: false,
    emergency2Relationship: false,
  };
  const [isInvalid, setIsInvalid] = React.useState(defaultIsInvalid);
  let textInputs = {
    emailAddress: React.useRef(null),
    firstName: React.useRef(null),
    lastName: React.useRef(null),
    phoneNumberHome: React.useRef(null),
    phoneNumberMobile: React.useRef(null),
    houseAddress: React.useRef(null),
    emergency1Name: React.useRef(null),
    emergency1PhoneNumber: React.useRef(null),
    emergency1EmailAddress: React.useRef(null),
    emergency1Relationship: React.useRef(null),
    emergency2Name: React.useRef(null),
    emergency2PhoneNumber: React.useRef(null),
    emergency2EmailAddress: React.useRef(null),
    emergency2Relationship: React.useRef(null),
  };

  let avatarPhotoRef = null;

  // runs each time screen is focused
  useFocusEffect(
    React.useCallback(() => {
      setIsInvalid(defaultIsInvalid);
      getUserProfile(user.id);
      getLocalization();
      // scrollRef.current.scrollTo({ x: 0, y: 0, animated: true });
      // if(Platform.OS !== 'web'){
        scrollRef.current.scrollToPosition(0, 0, true);
      // }
      console.log('scrollRef: ', scrollRef);
      checkLocalAuthentication();
    }, [user.id])
  );

  React.useEffect(() => {
    console.log('route.params.verify: ', route.params?.verify);
    if (route.params?.verify && route.params.verify === 'yes' && Platform.OS !== 'web'){
      scrollRef.current.scrollToEnd(true);
    }
  }, [route.params?.verify])
  
  const checkLocalAuthentication = async () => {
    setShowLocalAuthentication(await isLocalAuthenticationAvailable());
    // let useLocalAuthentication = await SecureStore.getItemAsync('useLocalAuthentication');
    // let localAuthenticationMessage = await SecureStore.getItemAsync('localAuthenticationMessage');
    let useLocalAuthentication = await Storage.getItem('useLocalAuthentication');
    let localAuthenticationMessage = await Storage.getItem('localAuthenticationMessage');
    setLocalAuthenticationMessage(localAuthenticationMessage);
    console.log('useLocalAuthentication: ', useLocalAuthentication);
    if (useLocalAuthentication === 'yes') {
      setUseLocalAuthentication(true);
    }else{
      setUseLocalAuthentication(false);
    }
  }
  const onChangeLocalAuthentication = async (use) => {
    console.log('onChangeLocalAuthentication', use);
    if(use){
      let authenticateAsync = await LocalAthentication.authenticateAsync();
      console.log('authenticateAsync', authenticateAsync);
      if (authenticateAsync.success) {
        // SecureStore.setItemAsync('useLocalAuthentication', 'yes');
        Storage.setItem('useLocalAuthentication', 'yes');
      }
    }else{
      // SecureStore.setItemAsync('useLocalAuthentication', 'no');
      // SecureStore.deleteItemAsync('username');
      // SecureStore.deleteItemAsync('password');
      Storage.setItem('useLocalAuthentication', 'no');
      Storage.removeItem('username');
      Storage.removeItem('password');
    }
  }
  const getUserProfile = async (userId) => {
    setLoading(true);

    rtApi.get(`users/${userId}`)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      setExistingProfile({...data.user});
      processUser(data.user);
    }).catch(err => {
      console.log(err);
    }).finally(() => {
      setLoading(false);
    });
  }
  const getLocalization = async () => {
    let { timezone, locale } = await Localization.getLocalizationAsync();
    setTimezone(timezone);
    setLocale(locale);
  }

  const processUser = (user) => {
    user = processLoginAccount(user, false);
    console.log('processUser: ', user);
    setEmailAddress(user.email_address);
    setCurrentEmailAddress(user.email_address);
    setFirstName(user.first_name);
    setLastName(user.last_name);
    setPhoneNumberHome(user.phone_number_home || '');
    setPhoneNumberMobile(user.phone_number_mobile || '');
    // setIsMobile(user.phone_number_mobile ? true : false);
    setAvatar(user.avatar);
    setStreetId(user.street_id);
    setStreetNumber(user.address_number);
    setAddressUnit(user.address_unit);
    setAddress(user.address);
    setUser(user);
    setEmergency1Name(user.emergency1_name || '');
    setEmergency1PhoneNumber(user.emergency1_phone_number || '');
    setEmergency1EmailAddress(user.emergency1_email_address || '');
    setEmergency1Relationship(user.emergency1_relationship || '');
    setEmergency2Name(user.emergency2_name || '');
    setEmergency2PhoneNumber(user.emergency2_phone_number || '');
    setEmergency2EmailAddress(user.emergency2_email_address || '');
    setEmergency2Relationship(user.emergency2_relationship || '');
    setPhotoIds(user.photoIds);
    setMarketingCommunication(user.marketing_communication === 'Yes' ? true : false);
    setCameraPreview(false);
    setAvatarChanged(false);
    setPhotoIdPreview(false);
  };

  const checkProfile = async () => {
    // setShowSuccessAlert(true);
    // return;
    console.log('checkProfile()');
    Keyboard.dismiss();
    // setShowSuccessAlert(true); // testing success alert
    // return;
    // emailAddress
    if (!Validate.Email(emailAddress)) {
      setIsInvalid(prevState => { return { ...prevState, emailAddress: true } });
      textInputs.emailAddress.current.focus();
      return;
    }
    // firstName
    if (!Validate.Name(firstName)) {
      setIsInvalid(prevState => { return { ...prevState, firstName: true } });
      textInputs.firstName.current.focus();
      return;
    }
    setIsInvalid(prevState => { return { ...prevState, firstName: false } });
    // lastName
    if (!Validate.Name(lastName)) {
      setIsInvalid(prevState => { return { ...prevState, lastName: true } });
      textInputs.lastName.current.focus();
      return;
    }
    setIsInvalid(prevState => { return { ...prevState, lastName: false } });
    // phoneNumbers
    let mobileValidated = Validate.PhoneNumber(phoneNumberMobile);
    let homeValidated = Validate.PhoneNumber(phoneNumberHome);
    if (!mobileValidated && !homeValidated) {
      if(!mobileValidated){
        setIsInvalid(prevState => { return { ...prevState, phoneNumberMobile: true } });
        textInputs.phoneNumberMobile.current.focus();
      }else{
        setIsInvalid(prevState => { return { ...prevState, phoneNumberHome: true } });
        textInputs.phoneNumberHome.current.focus();
      }
      return;
    }
    if (!mobileValidated && phoneNumberMobile && phoneNumberMobile.trim().length >= 1){
      setIsInvalid(prevState => { return { ...prevState, phoneNumberMobile: true } });
      textInputs.phoneNumberMobile.current.focus();
      return;
    } else if (!homeValidated && phoneNumberHome && phoneNumberHome.trim().length >= 1){
      setIsInvalid(prevState => { return { ...prevState, phoneNumberHome: true } });
      textInputs.phoneNumberHome.current.focus();
      return;
    }
    // setIsInvalid(prevState => { return { ...prevState, phoneNumber: false } });

    if (!streetId) {
      setIsInvalid(prevState => { return { ...prevState, houseAddress: true } });
      textInputs.houseAddress.current.focus();
      return;
    }
    if(emailAddress !== currentEmailAddress){
      //they changed their email, check its not currently in use by another user
      let existingResult = await Validate.isExistingEmail(emailAddress);
      console.log('existingResult', existingResult);
      if (existingResult) {
        setEmailAddress(currentEmailAddress);
        setAlertOptions({ visible: true, title: 'Existing Email Address', message: 'This email address has already been used to create an account by another user. Email address has been reverted to your current email address.', });
        // Alert.alert('Existing Email Address', 'This email address has already been used to create an account by another user. Email address has been reverted to your current email address.')
        return;
      }
    }
    saveProfile();
  };

  const onChangeEmailAddress = (emailAddress) => {
    if (isInvalid.emailAddress && Validate.Email(emailAddress)) {
      setIsInvalid(prevState => { return { ...prevState, emailAddress: false } });
    }
    setEmailAddress(emailAddress);
  };
  const onChangeFirstName = (firstName) => {
    if (isInvalid.firstName && Validate.Name(firstName)) {
      setIsInvalid(prevState => { return { ...prevState, firstName: false } });
    }
    setFirstName(firstName);
  };
  const onChangeLastName = (lastName) => {
    if (isInvalid.lastName && Validate.Name(lastName)) {
      setIsInvalid(prevState => { return { ...prevState, lastName: false } });
    }
    setLastName(lastName);
  };
  const onChangePhoneNumberHome = (phoneNumber) => {
    phoneNumber = formatPhoneNumber(phoneNumber);
    if (isInvalid.phoneNumberHome && Validate.PhoneNumber(phoneNumber)) {
      setIsInvalid(prevState => { return { ...prevState, phoneNumberHome: false } });
    }
    setPhoneNumberHome(phoneNumber);
  };
  const onChangePhoneNumberMobile = (phoneNumber) => {
    phoneNumber = formatPhoneNumber(phoneNumber);
    if (isInvalid.phoneNumberMobile && Validate.PhoneNumber(phoneNumber)) {
      setIsInvalid(prevState => { return { ...prevState, phoneNumberMobile: false } });
    }
    setPhoneNumberMobile(phoneNumber);
  };
  const onChangeEmergency1Name = (input) => {
    if (isInvalid.emergency1Name && Validate.Name(input)) {
      setIsInvalid(prevState => { return { ...prevState, emergency1Name: false } });
    }
    setEmergency1Name(input);
  };
  const onChangeEmergency1PhoneNumber = (input) => {
    input = formatPhoneNumber(input);
    if (isInvalid.emergency1PhoneNumber && Validate.PhoneNumber(input)) {
      setIsInvalid(prevState => { return { ...prevState, emergency1PhoneNumber: false } });
    }
    setEmergency1PhoneNumber(input);
  };
  const onChangeEmergency1EmailAddress = (input) => {
    if (isInvalid.emergency1EmailAddress && Validate.Email(input)) {
      setIsInvalid(prevState => { return { ...prevState, emergency1EmailAddress: false } });
    }
    setEmergency1EmailAddress(input);
  };
  const onChangeEmergency1Relationship = (input) => {
    if (isInvalid.emergency1Relationship && Validate.Blank(input)) {
      setIsInvalid(prevState => { return { ...prevState, emergency1Relationship: false } });
    }
    setEmergency1Relationship(input);
  };
  const onChangeEmergency2Name = (input) => {
    if (isInvalid.emergency2Name && Validate.Name(input)) {
      setIsInvalid(prevState => { return { ...prevState, emergency2Name: false } });
    }
    setEmergency2Name(input);
  };
  const onChangeEmergency2PhoneNumber = (input) => {
    input = formatPhoneNumber(input);
    if (isInvalid.emergency2PhoneNumber && Validate.PhoneNumber(input)) {
      setIsInvalid(prevState => { return { ...prevState, emergency2PhoneNumber: false } });
    }
    setEmergency2PhoneNumber(input);
  };
  const onChangeEmergency2EmailAddress = (input) => {
    if (isInvalid.emergency2EmailAddress && Validate.Email(input)) {
      setIsInvalid(prevState => { return { ...prevState, emergency2EmailAddress: false } });
    }
    setEmergency2EmailAddress(input);
  };
  const onChangeEmergency2Relationship = (input) => {
    if (isInvalid.emergency2Relationship && Validate.Blank(input)) {
      setIsInvalid(prevState => { return { ...prevState, emergency2Relationship: false } });
    }
    setEmergency2Relationship(input);
  };

  const previewAvatarPhoto = async () => {
    const permissionResult = await Camera.requestCameraPermissionsAsync();
    if (!permissionResult.granted) {
      // Alert.alert("Permission to access camera is required!");
      setAlertOptions({ visible: true, title: 'Error', message: 'Permission to access camera is required', });
      return;
    }
    setCameraPreview(true);
  }
  const takeAvatarPhoto = async () => {
    console.log('take photo id');
    if (avatarPhotoRef) {
      let result = await avatarPhotoRef.takePictureAsync({
        quality: Images.quality,
        base64: false,
        exif: false,
      });
      if (!result.cancelled) {
        setAvatar(result);
        setAvatarChanged(true);
        cancelCameraPreview();
      }
    }
  }
  const cancelCameraPreview = () => {
    setCameraPreview(false);
  }
  const reverseCamera = () => {
    setCameraType(
      cameraType === CameraType.back
        ? CameraType.front
        : CameraType.back
    );
  }
  const chooseAvatarPhoto = async () => {
    // if (Constants.platform.ios) {
    let permissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync();
    // }
    if (permissionResult.granted === false) {
      // Alert.alert("Permission to access camera roll is required!");
      setAlertOptions({ visible: true, title: 'Error', message: 'Permission to access media library is required!', });
      return;
    }
    // setAvatar(null);
    setAvatarChanged(false);
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: true,
      aspect: [1, 1],
      quality: 1,
    });
    if (!result.canceled) {
      if (Platform.OS === 'web') {
        result.assets[0].file = await dataUrlToFile(result.assets[0].uri);
      }

      const isValidExtension = isImageExtensionValid(Platform.OS === 'web' ? result.assets[0].file.name : result.assets[0].uri);
      if (!isValidExtension.result) {
        setAlertOptions({ visible: true, title: 'Error', message: `Invalid image type. Images must end in one of the following extensions: ${isValidExtension.extensions}`, });
        return;
      }

      console.log('chooseAvatarPhoto',result);
      setAvatar(result.assets[0]);
      setAvatarChanged(true);
    }else{
      console.log('cancelled...');
    }
  };
  // const getImageFieldsForUpload = (uri) => {
  //   let filename = uri.split('/').pop();
  //   // Infer the type of the image
  //   let match = /\.(\w+)$/.exec(filename);
  //   let type = match ? `image/${match[1]}` : `image`;

  //   return { filename: filename, type: type };
  // };
  const buildFormData = () => {
    let fd = new FormData();
    fd.append('time_zone', timezone);
    fd.append('language', locale);
    if (phoneNumberHome && String(phoneNumberHome) !== String(existingProfile.phone_number_home)) {
      fd.append('phone_number_home', phoneNumberHome);
    }
    if (phoneNumberMobile && String(phoneNumberMobile) !== String(existingProfile.phone_number_mobile)) {
      fd.append('phone_number_mobile', phoneNumberMobile);
    }
    if (emailAddress && String(emailAddress) !== String(existingProfile.email_address)){
      fd.append('email_address', emailAddress);
    }
    if (firstName && String(firstName) !== String(existingProfile.first_name)) {
      fd.append('first_name', firstName);
    }
    if (lastName && String(lastName) !== String(existingProfile.last_name)) {
      fd.append('last_name', lastName);
    }
    if(
      (streetId && String(streetId) !== String(existingProfile.street_id))
      ||
      (streetNumber && String(streetNumber) !== String(existingProfile.address_number))
      ||
      (addressUnit && String(addressUnit) != String(existingProfile.address_unit))
    ){
      fd.append('street_id', streetId);
      fd.append('address_number', streetNumber);
      fd.append('address_unit', addressUnit);
    }
    if (emergency1Name && String(emergency1Name) !== String(existingProfile.emergency1_name)){
      fd.append('emergency1_name', emergency1Name);
    }
    if (emergency1PhoneNumber && String(emergency1PhoneNumber) !== String(existingProfile.emergency1_phone_number)) {
      fd.append('emergency1_phone_number', emergency1PhoneNumber);
    }
    if (emergency1EmailAddress && String(emergency1EmailAddress) !== String(existingProfile.emergency1_email_address)) {
      fd.append('emergency1_email_address', emergency1EmailAddress);
    }
    if (emergency1Relationship && String(emergency1Relationship) !== String(existingProfile.emergency1_relationship)) {
      fd.append('emergency1_relationship', emergency1Relationship);
    }
    if (emergency2Name && String(emergency2Name) !== String(existingProfile.emergency2_name)) {
      fd.append('emergency2_name', emergency2Name);
    }
    if (emergency2PhoneNumber && String(emergency2PhoneNumber) !== String(existingProfile.emergency2_phone_number)) {
      fd.append('emergency2_phone_number', emergency2PhoneNumber);
    }
    if (emergency2EmailAddress && String(emergency2EmailAddress) !== String(existingProfile.emergency2_email_address)) {
      fd.append('emergency2_email_address', emergency2EmailAddress);
    }
    if (emergency2Relationship && String(emergency2Relationship) !== String(existingProfile.emergency2_relationship)) {
      fd.append('emergency2_relationship', emergency2Relationship);
    }
    if (marketingCommunicationChanged) {
      fd.append('marketing_communication', marketingCommunication ? 'Yes' : 'No');
    }
    if (avatar && avatarChanged) {
      if(Platform.OS !== 'web'){
        let imgDetails = getImageFieldsForUpload(avatar.uri);
        fd.append('avatar_file', {
          uri: avatar.uri,
          name: imgDetails.filename,
          type: imgDetails.type,
        });
      }else{
        fd.append('avatar_file', avatar.file);
      }
    }

    photoIds.forEach((p, i) => {
      if(!p.existing){
        if (Platform.OS !== 'web') {
          let idDetails = getImageFieldsForUpload(p.uri);
          fd.append('government_id' + (i + 1), {
            uri: p.uri,
            name: idDetails.filename,
            type: idDetails.type,
          });
        }else{
          fd.append('government_id' + (i + 1), p.file);
        }
      }
    });

    return fd;
  }
  const saveProfile = async () => {
    setLoading(true);
    const fd = buildFormData();
    console.log('formData', fd);
    return rtApi.put(`users/${user.id}`, fd)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log(data);
      if (data.result) {
        showAlert('success', 'Successfully Saved', () => linkTo('/projects'));
        processUser(data.session.account);
      } else {
        showAlert('error', data.errors.join('; '));
      }
    })
    .catch((error) => {
      console.log(error);
    }).finally(() => {
      setLoading(false);
    });
  };

  const setIsInvalidLocation = (val) => {
    setIsInvalid(prevState => { return { ...prevState, houseAddress: val } });
  }

  const scrollToEnd = () => {
    if(Platform.OS === 'web'){ return; }
    setTimeout(() => {
      // scrollToEnd does not work on web, scrollToPosition does
      // scrollRef.current.scrollToEnd({ animated: true });
      scrollRef.current.scrollToEnd(true);
      // scrollRef.current.scrollToPosition(0, 0, true);
    }, 250);
  }

  // const addNewPhoto = () => {
  //   if (Platform.OS !== 'web') {
  //     previewPhotoId();
  //   } else {
  //     choosePhoto();
  //   }
  // }
  const addNewPhoto = () => {
    let alertButtons = [];
    if (Platform.OS !== 'web') {
      alertButtons = [
        {
          text: 'Take Photo',
          onPress: () => previewPhotoId(),
        },
        {
          text: 'Choose PDF Document',
          onPress: () => choosePDF(),
        }
      ];
    } else {
      alertButtons = [
        {
          text: 'Choose Photo',
          onPress: () => choosePhoto(),
        },
        {
          text: 'Choose PDF Document',
          onPress: () => choosePDF(),
        }
      ]
    }
    setAlertOptions({
      visible: true,
      title: 'Choose an option',
      message: 'Choose one of the following options.',
      buttons: alertButtons,
      dismissable: true,
    });
  }
  const choosePDF = async () => {
    const result = await DocumentPicker.getDocumentAsync({ type: 'application/pdf' });
    console.log('choosePDF()', result);
    if (result.type === 'success') {
      result.fileType = 'pdf';
      // props.setBusinessId(result);
      setPhotoIds(prevState => {
        const ids = [...prevState];
        ids.push(result);
        console.log('inside state change', ids);
        return ids;
      });
    }
  }
  const previewPhotoId = async () => {
    const permissionResult = await Camera.requestCameraPermissionsAsync();
    if (!permissionResult.granted) {
      // Alert.alert("Permission to access camera is required!");
      setAlertOptions({ visible: true, title: 'Error', message: 'Permission to access camera is required!', });
      return;
    }
    setPhotoIdPreview(true);
    // scrollToPosition(photoIdPreviewLayoutY);
    scrollToEnd();
  }
  const takePhotoId = async () => {
    console.log('take photo id', photoIdRef);
    if (photoIdRef) {
      let result = await photoIdRef.takePictureAsync({
        quality: Images.quality,
        base64: false,
        exif: false,
      });
      console.log('result: ', result);
      if (!result.cancelled) {
        const manipResult = await manipulateImage(result, Images.identification.width, Images.identification.height);
        if(!manipResult.cancelled){
          cancelPhotoIdPreview();
          setPhotoIds(prevState => {
            const ids = [...prevState];
            manipResult.existing = false;
            manipResult.fileType = 'image';
            ids.push(manipResult);
            console.log('inside state change', ids);
            return ids;
          });
          scrollToEnd();
        }
      }
    }
  }
  const removePhotoId = (uri) => {
    console.log('removePhotoId: ', uri);
    setPhotoIds(prevState => {
      return prevState.filter(id => {
        return id.uri !== uri;
      });
    })
  };
  const removePhotoIdText = (version) => {
    console.log('removePhotoIdText: ', version);
    setPhotoIds(prevState => {
      return prevState.filter(id => {
        return id.version !== version;
      });
    })
  };
  const cancelPhotoIdPreview = () => {
    setPhotoIdPreview(false);
  }
  const photoIconContainerStyle = () => {
    let style = {
      position: 'absolute',
      bottom: 12,
      left: middleScreen - 90,
      padding: 16,
      borderRadius: 100,
      backgroundColor: Colors.lightBlue,
      height: 66,
      width: 66,
      alignItems: 'center',
      justifyContent: 'center'
    };
    if(Platform.OS === 'web'){
      style.bottom = 0;
      style.left = middleScreen - 23;
    }
    return style;
  }
  const cameraIconContainerStyle = () => {
    return {
      position: 'absolute',
      bottom: 12,
      left: middleScreen + 24,
      padding: 16,
      borderRadius: 100,
      backgroundColor: Colors.lightBlue,
      height: 66,
      width: 66,
      alignItems: 'center',
      justifyContent: 'center'
    };
  }
  const choosePhoto = async () => {
    console.log('choosePhoto()');
    let permissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync();
    if (permissionResult.granted === false) {
      setAlertOptions({ visible: true, title: 'Warning', message: 'Permission to access camera roll is required!', });
      return;
    }
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: true,
      // aspect: [1, 1],
      quality: 1,
    });

    if (!result.canceled) {
      result.assets[0].existing = false;
      result.assets[0].fileType = 'image';
      if (Platform.OS === 'web') {
        result.assets[0].file = await dataUrlToFile(result.assets[0].uri);
      }
      console.log('result: ', result);
      const isValidExtension = isImageExtensionValid(Platform.OS === 'web' ? result.assets[0].file.name : result.assets[0].uri);
      if (!isValidExtension.result) {
        setAlertOptions({ visible: true, title: 'Error', message: `Invalid image type. Images must end in one of the following extensions: ${isValidExtension.extensions}`, });
        return;
      }
      setPhotoIds(prevState => {
        const ids = [...prevState];
        ids.push(result.assets[0]);
        console.log('inside state change', ids);
        return ids;
      });
      setTimeout(() => {
        scrollToEnd();
      }, 250);
    }
  };

  const removeApplicationData = async () => {
    setLoading(true);
    await Promise.all([
      Storage.removeItem('rtJWT'),
      Storage.removeItem('user'),
      Storage.removeItem('userId'),
      Storage.removeItem('socialId'),
      Storage.removeItem('username'),
      Storage.removeItem('password'),
      Storage.removeItem('deepLink'),
      Storage.removeItem('useLocalAuthentication'),
      Storage.removeItem('localAuthenticationMessage'),
      Storage.removeItem('localAuthenticationButtonText'),
      Storage.removeItem('localAuthenticationButtonType'),
    ]);
    setLoading(false);
  }

  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      linkTo(`/projects`);
    }
  }

  const promptDeleteAccount = () => {
    setAlertOptions({
      visible: true,
      title: 'Confirm',
      message: 'Are you sure you want to delete your account? This action cannot be undone.',
      buttons: [
        {
          text: 'Cancel',
          onPress: () => { },
          style: 'cancel',
        },
        {
          text: 'Delete',
          onPress: () => deleteAccount(),
          style: 'destructive',
        }
      ]
    })
  }

  const deleteAccount = () => {
    //testing
    // setLoading(true);
    // setTimeout(() => {
    //   setLoading(false);
    //   afterDeleteAccount();
    // }, 3000);

    // production
    setLoading(true);
    return rtApi.put(`users/delete/${user.id}`)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log(data);
      if (data.result) {
        afterDeleteAccount();
      }
    })
    .catch((error) => {
      console.log(error);
    }).finally(() => {
      setLoading(false);
    });
  }

  const afterDeleteAccount = () => {
    setAlertOptions({
      visible: true,
      title: 'Deleted',
      message: 'Your account has been successfully deleted.',
      buttons: [
        {
          text: 'OK',
          onPress: () => removeEverything(),
        }
      ]
    })
  }

  const removeEverything = async () => {
    await Promise.all([
      Storage.removeItem('useLocalAuthentication'),
      Storage.removeItem('rtJWT'),
      Storage.removeItem('apiRequestTime'),
      Storage.removeItem('socialId'),
      Storage.removeItem('username'),
      Storage.removeItem('password'),
      Storage.removeItem('user'),
      Storage.removeItem('userId'),
      Storage.removeItem('rtDisputeFees'),
      Storage.removeItem('localAuthenticationMessage'),
      Storage.removeItem('localAuthenticationButtonText'),
      Storage.removeItem('localAuthenticationType'),
      Storage.removeItem('deepLink'),
    ]);
    setUser({ isLoggedIn: false });
  }

  return (
    <View style={CS.safe}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <Alert options={alertOptions} setOptions={setAlertOptions} />
      <KeyboardAwareScrollView keyboardShouldPersistTaps='handled' style={styles.container} contentContainerStyle={[styles.innerContainer, { paddingTop: insets.top, paddingBottom: insets.bottom }]} ref={scrollRef}>
        <View style={styles.titleContainer}>
          <Text style={[CS.mediumTitle, CS.lightText, CS.centerText, CS.noMargin]}>My Profile</Text>
          <TouchableOpacity onPress={goBack} style={styles.backArrow}>
            <FontAwesome5 name="arrow-left" size={24} color="white" />
          </TouchableOpacity>
        </View>
        
        <View style={styles.avatarPickerContainer}>
          {cameraPreview &&
            <>
              <View style={styles.avatarContainer}>
                <Camera style={{ width: Images.avatar.width, height: Images.avatar.height }} type={cameraType} ref={ref => avatarPhotoRef = ref}></Camera>
              </View>
              <TouchableOpacity style={[styles.previewIconContainer, styles.previewCancel]} onPress={() => cancelCameraPreview()} underlayColor={Colors.red}>
                <FontAwesome name="remove" size={32} color="white" />
              </TouchableOpacity>
              <TouchableOpacity style={[styles.previewIconContainer, styles.previewReverse]} onPress={() => reverseCamera()} activeOpacity={0.6}>
                <FontAwesome name="refresh" size={32} color='white' />
              </TouchableOpacity>
              <TouchableOpacity style={[styles.previewIconContainer, styles.previewTake]} onPress={() => takeAvatarPhoto()} underlayColor={Colors.yellow}>
                <FontAwesome name="check" size={32} color="white" />
              </TouchableOpacity>
            </>
          }
          {!cameraPreview && avatar && !avatarChanged &&
            // <CachedImage source={{ uri: avatar }} style={{ width: Images.avatar.width, height: Images.avatar.height }} />
            // <View>
              <UserAvatar size='xlarge' userId={user.id} avatar={user.avatar} borderColor={Colors.lightGrey} />
            // </View>
          }
          {!cameraPreview && avatar && avatarChanged &&
            <View style={styles.avatarContainer}>
              <Image source={{ uri: avatar.uri }} style={{ width: Images.avatar.width, height: Images.avatar.height }} />
            </View>
          }
            {/* <Image source={{ uri: 'https://dev.nethire.com/test/chad/202.jpeg' }} style={styles.avatar} /> */}
          {!cameraPreview && !avatar &&
            <FontAwesome name="user-circle-o" size={186} color={Colors.lightGrey} style={styles.avatarBlank} />
          }
          {!cameraPreview &&
            <>
              <TouchableHighlight style={photoIconContainerStyle()} onPress={chooseAvatarPhoto} underlayColor={Colors.yellow}>
                <FontAwesome name="photo" size={32} color="white" />
              </TouchableHighlight>
              {Platform.OS !== 'web' 
              ?
              <TouchableHighlight style={cameraIconContainerStyle()} onPress={previewAvatarPhoto} underlayColor={Colors.yellow}>
                <FontAwesome name="camera" size={32} color="white" />
              </TouchableHighlight>
              : null}
            </>
          }
        </View>
        {/* <Text style={[CS.smallText, CS.lightText]} onPress={() => testAvatarWebBrowser(avatar)}>{avatar}</Text> */}
        {/* <Text style={[CS.smallText, CS.lightText]}>{avatar}</Text> */}

        {showLocalAuthentication &&
          <View style={{ marginBottom: 20 }}>
            <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>{localAuthenticationMessage}</Text>
            <ToggleButtons setValue={setUseLocalAuthentication} value={useLocalAuthentication} button1Text={"Yes"} button2Text={"No"} onChange={onChangeLocalAuthentication} />
          </View>
        }
        {/* <YesNoToggle setValue={setUseLocalAuthentication} value={useLocalAuthentication} text={localAuthenticationMessage} onChange={onChangeLocalAuthentication} /> */}
        <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Email Address</Text>
        <TextInputContainer
          iconName='envelope'
          placeholder='Email Address'
          textContentType='username'
          onChangeText={(t) => onChangeEmailAddress(t)}
          inputRef={textInputs.emailAddress}
          keyboardType='email-address'
          // autoFocus={true} 
          isInvalid={isInvalid.emailAddress}
          value={emailAddress}
          autoCapitalize='none'
          autocompleteType='username'
          autoCorrect={false}
          clear-button-mode='while-editing'
          returnKeyType='done'
        />
        <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>First Name</Text>
        <TextInputContainer
          iconName='user'
          placeholder='First Name'
          textContentType='givenName'
          onChangeText={(t) => onChangeFirstName(t)}
          value={firstName}
          inputRef={textInputs.firstName}
          isInvalid={isInvalid.firstName}
          autoCompleteType='name'
          returnKeyType='done'
        />
        <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Last Name</Text>
        <TextInputContainer
          iconName='user'
          placeholder='Last Name'
          textContentType='familyName'
          onChangeText={(t) => onChangeLastName(t)}
          value={lastName}
          inputRef={textInputs.lastName}
          isInvalid={isInvalid.lastName}
          autoCompleteType='name'
          returnKeyType='done'
        />
        <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Mobile Phone Number</Text>
        <TextInputContainer
          iconName='mobile'
          placeholder='Mobile Phone Number'
          textContentType='telephoneNumber'
          keyboardType='phone-pad'
          autoCompleteType='tel'
          onChangeText={(t) => onChangePhoneNumberMobile(t)}
          value={phoneNumberMobile}
          inputRef={textInputs.phoneNumberMobile}
          isInvalid={isInvalid.phoneNumberMobile}
          returnKeyType='done'
        />
        <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Home Phone Number</Text>
        <TextInputContainer
          iconName='phone'
          placeholder='Home Phone Number'
          textContentType='telephoneNumber'
          keyboardType='phone-pad'
          autoCompleteType='tel'
          onChangeText={(t) => onChangePhoneNumberHome(t)}
          value={phoneNumberHome}
          inputRef={textInputs.phoneNumberHome}
          isInvalid={isInvalid.phoneNumberHome}
          returnKeyType='done'
        />
        <View style={[CS.rowContainer, styles.inputLabel]}>
          <Text style={[CS.smallText, CS.lightBlueText]}>Home Address</Text>
          <ToolTipWrapper
            text={addressToolTip}
          />
        </View>
        <AddressPicker
          iconName='home'
          placeholder='Home Address'
          value={address}
          offsetTop={Constants.statusBarHeight}
          setAddress={setAddress}
          setStreetId={setStreetId}
          setStreetNumber={setStreetNumber}
          setAddressUnit={setAddressUnit}
          isSet={streetId ? true : false}
          // isSet={true}
          inputRef={textInputs.houseAddress}
          setIsInvalid={setIsInvalidLocation}
          isInvalid={isInvalid.houseAddress}
        />
        {/* emergency contacts */}
        <Text style={[CS.smallTitle, CS.lightText, { marginVertical: 10 }]}>Emergency Contacts</Text>
        <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>We use push notifications, SMS, email and telephone calls to communicate directly with you. If something terrible should happen to you, and we can't get ahold of you during a dispute or the releasing of funds, we will reach out to the contacts you provide below to help locate your whereabouts. This is completely optional.</Text>
        <Text style={[CS.smallTitle, CS.lightText, { marginVertical: 10 }]}>Contact #1</Text>
        <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Full Name</Text>
        <TextInputContainer
          iconName='user'
          placeholder='Full Name'
          textContentType='name'
          onChangeText={(t) => onChangeEmergency1Name(t)}
          inputRef={textInputs.emergency1Name}
          keyboardType='default'
          // autoFocus={true} 
          isInvalid={isInvalid.emergency1Name}
          value={emergency1Name}
          autoCapitalize='words'
          autoCompleteType='off'
          autoCorrect={false}
          returnKeyType='done'
        />
        <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Phone Number</Text>
        <TextInputContainer
          iconName='phone'
          placeholder='Phone Number'
          textContentType='telephoneNumber'
          keyboardType='phone-pad'
          autoCompleteType='tel'
          onChangeText={(t) => onChangeEmergency1PhoneNumber(t)}
          value={emergency1PhoneNumber}
          inputRef={textInputs.emergency1PhoneNumber}
          isInvalid={isInvalid.emergency1PhoneNumber}
          returnKeyType='done'
        />
        <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Email Address</Text>
        <TextInputContainer
          iconName='envelope'
          placeholder='Email Address'
          textContentType='username'
          onChangeText={(t) => onChangeEmergency1EmailAddress(t)}
          inputRef={textInputs.emergency1EmailAddress}
          keyboardType='email-address'
          // autoFocus={true} 
          isInvalid={isInvalid.emergency1EmailAddress}
          value={emergency1EmailAddress}
          autoCapitalize='none'
          autoCompleteType='username'
          autoCorrect={false}
          returnKeyType='done'
        />
        <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Relationship</Text>
        <TextInputContainer
          iconName='user'
          placeholder='Relationship'
          textContentType='none'
          onChangeText={(t) => onChangeEmergency1Relationship(t)}
          inputRef={textInputs.emergency1Relationship}
          keyboardType='default'
          // autoFocus={true} 
          isInvalid={isInvalid.emergency1Relationship}
          value={emergency1Relationship}
          autoCapitalize='words'
          autoCompleteType='off'
          autoCorrect={false}
          returnKeyType='done'
        />

        <Text style={[CS.smallTitle, CS.lightText, { marginVertical: 10 }]}>Contact #2</Text>
        <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Full Name</Text>
        <TextInputContainer
          iconName='user'
          placeholder='Full Name'
          textContentType='name'
          onChangeText={(t) => onChangeEmergency2Name(t)}
          inputRef={textInputs.emergency2Name}
          keyboardType='default'
          // autoFocus={true} 
          isInvalid={isInvalid.emergency2Name}
          value={emergency2Name}
          autoCapitalize='words'
          autoCompleteType='off'
          autoCorrect={false}
          returnKeyType='done'
        />
        <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Phone Number</Text>
        <TextInputContainer
          iconName='phone'
          placeholder='Phone Number'
          textContentType='telephoneNumber'
          keyboardType='phone-pad'
          autoCompleteType='tel'
          onChangeText={(t) => onChangeEmergency2PhoneNumber(t)}
          value={emergency2PhoneNumber}
          inputRef={textInputs.emergency2PhoneNumber}
          isInvalid={isInvalid.emergency2PhoneNumber}
          returnKeyType='done'
        />
        <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Email Address</Text>
        <TextInputContainer
          iconName='envelope'
          placeholder='Email Address'
          textContentType='username'
          onChangeText={(t) => onChangeEmergency2EmailAddress(t)}
          inputRef={textInputs.emergency2EmailAddress}
          keyboardType='email-address'
          // autoFocus={true} 
          isInvalid={isInvalid.emergency2EmailAddress}
          value={emergency2EmailAddress}
          autoCapitalize='none'
          autoCompleteType='username'
          autoCorrect={false}
          returnKeyType='done'
        />
        <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Relationship</Text>
        <TextInputContainer
          iconName='user'
          placeholder='Relationship'
          textContentType='none'
          onChangeText={(t) => onChangeEmergency2Relationship(t)}
          inputRef={textInputs.emergency2Relationship}
          keyboardType='default'
          // autoFocus={true} 
          isInvalid={isInvalid.emergency2Relationship}
          value={emergency2Relationship}
          autoCapitalize='words'
          autoCompleteType='off'
          autoCorrect={false}
          returnKeyType='done'
        />

        {/* photo ids */}
        <>
          <Text style={[CS.smallTitle, CS.lightText]}>Photos of government-issued ID</Text>
          <Text style={[CS.smallText, CS.lightBlueText]}>Acceptable IDs:</Text>
          <View style={styles.acceptableIdsList}>
            {acceptableIds.map((v, index) => { return (<ULItem text={v} key={index} textColor='lightBlue' />); })}
          </View>
          {!showMore && 
            <TouchableOpacity activeOpacity={0.6} onPress={() => { setShowMore(true); }} style={{ marginBottom: 10 }}><Text style={[CS.smallText, CS.lightBlueText]}>More ...</Text></TouchableOpacity>
          }
          {showMore && 
            <>
            <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10, marginTop: 10 }]}>You must be verified in order to send or receive money. You can setup a project without being verified, however no money can be exchanged.</Text>
            <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>Your identification is only used by Renovation Trust personnel for the purposes of verifying your identity and is never sold. It is also not shared with contractors or homeowners.</Text>
            <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>2 government-issued IDs are required to become verified</Text>
            <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 20 }]}>Supported file formats include: jpg, png, tif, gif, webp</Text>
            {/* <TouchableOpacity activeOpacity={0.6} onPress={() => { setShowMore(false); }} style={{ marginBottom: 10 }}><Text style={[CS.smallText, CS.lightBlueText]}>Less ...</Text></TouchableOpacity> */}
            </>
          }
        {/* <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>{photoIds[0].uri}</Text>
        <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>{photoIds[1].uri}</Text> */}
          
          {/* ids */}
          <View style={styles.ids}>
            {/* {photoIds.map((id, index) => { return (<PhotoIdText name={id.name} key={index} remove={removePhotoId} />); })} */}
            {/* {photoIds.map((id, index) => { return (<PhotoId uri={id.uri} key={index} remove={removePhotoId} />); })} */}
            {photoIds.map((id, index) => {
              if(id.existing){
                return (<PhotoIdText type={id.type} version={id.version} key={index} remove={removePhotoIdText} />);
              }
              return (<PhotoId uri={id.uri} fileType={id.fileType} fileName={id.name || ''} key={index} remove={removePhotoId} width={id.width} height={id.height} />);
            })}
            {photoIdPreview &&
              <View style={styles.photoIdPreviewContainer}>
                <Camera style={styles.photoIdPreview} type={CameraType.back} ref={ref => photoIdRef = ref}>
                  <Text style={styles.takePhotoIdText}>Take a photo of your ID</Text>
                </Camera>
                <View style={CS.rowContainer}>
                  <View style={CS.buttonLeft}>
                    <Button text='Cancel' onPress={() => cancelPhotoIdPreview} color='blue' />
                  </View>
                  <View style={CS.buttonRight}>
                    <Button text='Take Photo' onPress={() => takePhotoId} />
                  </View>
                </View>
              </View>
            }
            {(!photoIdPreview && photoIds.length < 2) && (
              <TouchableOpacity style={styles.addNewId} onPress={addNewPhoto}>
                <FontAwesome5 name="address-card" size={80} color={Colors.lightBlue} />
                <Text style={[CS.boldText, styles.addNewText]}>Add New</Text>
              </TouchableOpacity>
            )}
          </View>

          <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 20 }]}>If you have concerns, difficulty or would like to provide alternate forms of identification, please reach out to us.</Text>
        </>
        <View style={{ marginBottom: 20 }}>
          <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>Receive marketing communication</Text>
          <ToggleButtons setValue={setMarketingCommunication} value={marketingCommunication} button1Text={"Yes"} button2Text={"No"} onChange={() => { setMarketingCommunicationChanged(true) }} />
        </View>
        {process.env.NODE_ENV === 'development' ?
          <View style={{ marginBottom: 20 }}>
            <TouchableOpacity activeOpacity={0.6} onPress={removeApplicationData}>
              <Text style={[CS.lightText, CS.miniText]}>Clear Application Data</Text>
            </TouchableOpacity>
          </View>
        : null}
        <View style={{ marginBottom: 20 }}>
          <Button text='Save' onPress={() => checkProfile} />
        </View>
        <View style={{ marginBottom: 20 }}>
          <Button text='Delete Account' color='red' onPress={() => promptDeleteAccount} />
        </View>
      </KeyboardAwareScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    // marginTop: 20,
    width: '100%',
    // marginVertical: 10,
    padding: 10,
    // backgroundColor: 'pink',
  },
  innerContainer: {
    width: '100%',
    // backgroundColor: 'blue',
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    justifyContent: 'center',
    flexGrow: 1,
    alignSelf: 'center'
  },
  signUp: {
    width: '100%',
    // marginTop: 'auto',
    // marginBottom: 'auto',
  },
  profile: {
    // marginTop: 20,
  },
  switchContainer: {
    marginBottom: 20,
  },
  switch: {
    marginRight: 10,
  },
  tabButtons: {
    marginLeft: 'auto',
  },
  tabButtonContainer: {
    paddingVertical: 10,
    paddingHorizontal: 30,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: Colors.lightBlue,
  },
  tabButtonContainerActive: {
    backgroundColor: Colors.yellow,
    borderColor: Colors.yellow,
  },
  tabButton: {
    color: Colors.lightText,
    textAlign: 'center',
    fontSize: 20,
  },
  tabButtonActive: {
    color: Colors.darkText,
  },
  left: {
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
  },
  right: {
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
  },
  avatarPickerContainer: {
    alignItems: 'center',
    position: 'relative',
    padding: 20,
    marginBottom: 20,
    // backgroundColor: 'pink',
  },
  avatarContainer: {
    borderRadius: 100,
    overflow: 'hidden',
    borderStyle: 'solid',
    borderWidth: 3,
    borderColor: Colors.lightGrey,
  },
  avatar: {
    width: 180,
    height: 180,
    // transform: [{rotateY:'180deg'}],
  },
  previewIconContainer: {
    position: 'absolute',
    padding: 12,
    borderRadius: 100,
    backgroundColor: Colors.lightBlue,
    height: 56,
    width: 56,
    alignItems: 'center',
    justifyContent: 'center'
  },
  previewCancel: {
    top: '80%',
    right: '70%',
  },
  previewReverse: {
    top: '90%',
    left: '47.5%',
  },
  previewTake: {
    top: '80%',
    left: '70%',
  },
  contractorText: {
    textAlign: 'right',
    flex: 1,
    marginRight: 10,
  },
  // suggestions
  addressContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    padding: 10,
    borderRadius: 10,
    zIndex: 2,
  },
  suggestionsCloseButton: {
    marginBottom: 10,
  },
  addressSuggestions: {
    position: 'absolute',
    top: 100,
    left: 10,
    width: '100%',
    borderColor: Colors.lightBlue,
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 10,
    // paddingBottom: 10,
    backgroundColor: Colors.textInputBackground,
  },
  addressSuggestion: {
    padding: 10,
    borderColor: Colors.lightBlue,
  },
  addressSuggestionBorder: {
    borderBottomWidth: 1,
  },
  addressSuggestionNoBorder: {
    borderBottomWidth: 0,
  },
  titleContainer: {
    marginVertical: 10
  },
  backArrow: {
    position:'absolute',
    top:5,
    left:0,
  },
  inputLabel: {
    marginBottom: 5,
  },


  acceptableIdsList: {
    marginTop: 10,
    marginBottom: 0,
  },
  ids: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    // marginBottom:20,
  },
  addNewId: {
    // alignItems: 'center',
    // justifyContent: 'center',
    // borderRadius: 10,
    // borderStyle: 'dashed',
    // borderWidth: 2,
    // borderColor: Colors.lightBlue,
    // width: '46%',
    // padding: 10,
    // marginHorizontal: '2%',
    // marginBottom: '4%',

    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 10,
    borderStyle: 'dashed',
    borderWidth: 2,
    borderColor: Colors.lightBlue,
    width: '100%',
    padding: 10,
    marginBottom: '4%',
  },
  addNewText: {
    color: Colors.lightBlue,
    fontSize: 24,
  },
  photoIdPreviewContainer: {
    width: '100%',
    height: 240,
    aspectRatio: Images.identification.width / Images.identification.height,
    marginBottom: 10,
  },
  photoIdPreview: {
    flex: 1,
    borderRadius: 10,
    justifyContent: 'center',
    marginBottom: 10,
    width: '100%',
    // aspectRatio: 1,
  },
  takePhotoIdText: {
    padding: 20,
    width: '100%',
    backgroundColor: Colors.transparentGrey,
    textAlign: 'center',
    fontSize: 24,
  },
});

export default React.memo(PersonalProfile);